import http from "@/request"
import axios from "axios";
import { getToken } from "@/cookie";

/**
 * 发票列表
 * @param {*} param 
 * @returns 
 */
export function mimeInvoiceList(param) {
    return http({
      url: "/invoice/list",
      method: "post",
      data: param,
    });
}

/**
 * 设置类别
 * @param {*} param 
 * @returns 
 */
export function updateType(param) {
  return http({
    url: "/invoice/updateType",
    method: "post",
    data: param,
  });
}

/**
 * 消息发票
 * @param {*} param 
 * @returns 
 */
export function processInvoiceList(param) {
  return http({
    url: "/invoice/processList",
    method: "post",
    data: param,
  });
}

/**
 * 删除账户
 * @param {*} param 
 * @returns 
 */
 export function deleteMimeInvoice(id) {
  return http({
    url: "/invoice/delete?id=" + id,
    method: "get",
  });
}

/**
 * 保存发票信息
 * @param {*} data 
 * @returns 
 */
export function saveInvoiceInfo(data) {
  return http({
    url: "/invoice/saveInvoiceByPC",
    method: "post",
    data: data
  });
}


/**
 * 上传发票
 * @param {*} file 
 * @returns 
 */
export function uploadInvoiceFile(file) {
  const formData = new FormData();
  formData.append('file', file); // 'file'是服务器端接收文件的字段名
  let token = getToken();
  return axios.post('/api/invoice/uploadPaperInvoiceForPc', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      'Authorization' : token
    }
  });
}


/**
 * 发票验真
 * @param {*} id 
 * @returns 
 */
export function invoiceVerify(id,flag) {
  return http({
    url: "/invoice/verify/" + id + '?force='+flag,
    method: "get",
  });
}
/**
 * 发票批量验真
 * @param {*} id 
 * @returns 
 */
export function verifyBatch(data) {
  return http({
    url: "/invoice/verifyBatch",
    method: "post",
    data
  });
}
/**
 * 发票批量验真
 * @param {*} id 
 * @returns 
 */
export function listInvoiceType() {
  return http({
    url: "/invoice/deduction/listInvoiceType",
    method: "get"
  });
}
/**
 * 发票抵扣列表
 * @param {*} id 
 * @returns 
 */
export function deductionPage(data) {
  return http({
    url: "/invoice/deduction/page",
    method: "post",
    data
  });
}
export function deductionDo(data) {
  return http({
    url: "/invoice/deduction/do",
    method: "post",
    data
  });
}
export function deductionCancel(data) {
  return http({
    url: "/invoice/deduction/cancel",
    method: "post",
    data
  });
}
export function deductionExport(data) {
  return http({
    url: "/invoice/deduction/export",
    method: "post",
    responseType: 'blob',
    data
  });
}



// WEBPACK FOOTER //
// ./src/api/invoice.js